import { Component, Input, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { CommonService } from "src/app/services/common.service";
import { PayoutInfoModalComponent } from "../../../modals/payment-info-modal/payout-info-modal.component";
import { ApiService } from "src/app/services/api.service";
import { Subject } from "rxjs";
import { StorageService } from "src/app/services/storage.service";
import { ClaimActionsService } from "src/app/pages/customer-dashboard/services/claim-actions.service";
import { CustomerDashboardService } from "src/app/pages/customer-dashboard/services/customer-dashboard.service";
import endpoints from "src/app/helpers/endpoints";
import { takeUntil } from "rxjs/operators";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { ErrorType } from "src/app/enums/error-type.enum";
import { ViewAssignedTechnicianComponent } from "../../../modals/view-assigned-technician/view-assigned-technician.component";
import { ClaimPrioritizationModalComponent } from "../../../modals/claim-prioritization-modal/claim-prioritization-modal.component";

@Component({
  selector: "fury-claim-table",
  templateUrl: "./claim-table.component.html",
  styleUrls: ["./claim-table.component.scss"],
})
export class ClaimTableComponent implements OnInit {
  @Input() displayedColumns: any[];
  @Input() dataSource: any[] = [];
  @Input() editorAccess: boolean;
  @Input() services: any;
  userId = "";
  ngUnsubscribe = new Subject<void>();

  agentId = "";
  constructor(
    public commonService: CommonService,
    private activateRoute: ActivatedRoute,
    public dialog: MatDialog,
    private apiService: ApiService,
    private storageService: StorageService,
    public claimActionsService : ClaimActionsService,
    private customerDashboardService: CustomerDashboardService
  ) {}

  ngOnInit(): void {
    this.userId = this.activateRoute.snapshot.params["id"];
    this.agentId = this.storageService.getUser()?.userId;
  }

  handleAddNotes(rowData: any) {
    const { agreementNumber, fileClaimId } = rowData;
    if (!agreementNumber || !this.userId || !fileClaimId) return;
    this.customerDashboardService.handleAddNotes(this.userId, null, false, agreementNumber, fileClaimId);
  }

  handleAddSpecialRequest(rowData: any) {
    const { agreementNumber, fileClaimId } = rowData;
    if (!agreementNumber || !this.userId || !fileClaimId) return;
    this.customerDashboardService.handleSpecialRequest(this.userId, null, false, fileClaimId, agreementNumber);
  }

  handleAddFeedback(rowData: any) {
    const { agreementNumber, fileClaimId } = rowData;
    if (!agreementNumber || !this.userId || !fileClaimId) return;
    this.customerDashboardService.handleFeedbackRequest(this.userId, null, false, fileClaimId, agreementNumber);
  }

  handleViewClaim(rowData: any) {
    const { fileClaimId } = rowData;
    if (!this.userId || !fileClaimId) return;
    this.apiService.routeToPage(
      `customer-dashboard/${this.userId}/view-claim/${fileClaimId}`
    );
  }

  handleSendEmail(rowData: any) {
    this.claimActionsService.updateFileClaimInfo(rowData?.fileClaimId, null, "sendAnEmail");
  }

  handlePaymentInfo(rowData: any) {
    this.dialog
      .open(PayoutInfoModalComponent, {
        data: rowData?.paymentDetails,
        width: "600px",
        panelClass: "payment-info",
      })
      .afterClosed()
      .subscribe((res: any) => {});
  }

  openActionModal(row: any, modalName: string){
    this.claimActionsService.openActionModal(row?.fileClaimId, modalName,  this.services, row?.propertyAddress?.zip);
  }

  redirectChangeStatusPage(rowData: any) {
    this.apiService.routeToPage(
      `customer-dashboard/${this.userId}/claim-status/${rowData?.fileClaimId}`
    );
  }
  handleViewAssignedTechnician(rowData: any) {
    this.dialog
      .open(ViewAssignedTechnicianComponent, {
        data: {...rowData, services: this.services},
        width: "600px",
        panelClass: "payment-info",
      })
      .afterClosed()
      .subscribe((res: boolean) => {});
  }
   handleClaimPrioritizationModal(rowData: any) {
      this.dialog
        .open(ClaimPrioritizationModalComponent, {
          data: rowData,
          width: "400px",
          panelClass: "payment-info",
        })
        .afterClosed()
        .subscribe((res: boolean) => {
          if(res){
            this.claimActionsService.setFetchCancelClaimData(true);
          }
        });
    }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
